import { b as bootstrapLazy } from './index-dcbafdc7.js';
export { s as setNonce } from './index-dcbafdc7.js';
import { g as globalScripts } from './app-globals-0f993ce5.js';

const defineCustomElements = async (win, options) => {
  if (typeof window === 'undefined') return undefined;
  await globalScripts();
  return bootstrapLazy([["graphql-playground-component",[[0,"graphql-playground-component",{"configuration":[16],"setLanguage":[64],"setEditorsTheme":[64]},null,{"configuration":["configurationChanged"]}]]]], options);
};

export { defineCustomElements };

//# sourceMappingURL=loader.js.map